import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import deTranslation from './assets/i18n/de.json';
import enTranslation from './assets/i18n/en.json';
import plTranslation from './assets/i18n/pl.json';
import { I18N_STORAGE_KEY } from './utils/constants';
import {
  DEFAULT_LOCALE,
  getLangParam,
  isSupportedLocale,
} from './utils/language';

export { DEFAULT_LOCALE };

const resources = {
  de: {
    translation: deTranslation,
  },
  en: {
    translation: enTranslation,
  },
  pl: {
    translation: plTranslation,
  },
};

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE;
  }

  // the lang query param takes priority over the stored preference
  const urlLanguage = getLangParam(window.location.search);
  if (urlLanguage !== null) {
    return isSupportedLocale(urlLanguage) ? urlLanguage : DEFAULT_LOCALE;
  }

  const savedLanguage = localStorage.getItem(I18N_STORAGE_KEY);
  return isSupportedLocale(savedLanguage) ? savedLanguage : DEFAULT_LOCALE;
};

const initialLanguage = getInitialLanguage();

if (typeof window !== 'undefined') {
  // keep links opened without the lang param in the language last seen
  localStorage.setItem(I18N_STORAGE_KEY, initialLanguage);
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: {
    escapeValue: false,
  },
});

// persist language changes to localStorage
i18n.on('languageChanged', (language) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(I18N_STORAGE_KEY, language);
    window.location.reload();
  }
});
